var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mess_box" },
    [
      _c(
        "vab-collapse",
        { attrs: { title: "コメント履歴を閉じる" } },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "me_item flex_start" },
            [
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(item.time || item.commentDatetime)),
              ]),
              item.status
                ? [
                    _c("div", { staticClass: "me_inner flex_colum" }, [
                      _c(
                        "div",
                        { staticClass: "flex_start flex_center_align" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/r9.png"),
                              alt: "",
                            },
                          }),
                          item.company
                            ? _c("span", { staticClass: "word" }, [
                                _vm._v(" " + _vm._s(item.company) + " "),
                              ])
                            : _c("span", { staticClass: "word" }, [
                                _vm._v(" " + _vm._s(item.partner) + " "),
                              ]),
                        ]
                      ),
                      _c("div", { staticClass: "state_box flex_colum" }, [
                        _c("div", { staticClass: "flex_start" }, [
                          _vm.getReportText(item.reportType)
                            ? _c("span", { staticClass: "report_format" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getReportText(item.reportType)) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          !_vm.isEqualCodeEnum(
                            item.status,
                            _vm.$divisions.reportStatusEnum.enum_04
                          )
                            ? _c(
                                "span",
                                { staticClass: "state_word_blue" },
                                [
                                  _c("svg-icon", {
                                    attrs: { "icon-class": "check_line" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getEnumText(
                                            item.status,
                                            _vm.$divisions.reportStatusEnum
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isEqualCodeEnum(
                            item.status,
                            _vm.$divisions.reportStatusEnum.enum_04
                          )
                            ? _c(
                                "span",
                                { staticClass: "state_word_red" },
                                [
                                  _c("svg-icon", {
                                    attrs: { "icon-class": "back_2_line" },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getEnumText(
                                            item.status,
                                            _vm.$divisions.reportStatusEnum
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        item.comment
                          ? _c("div", { staticClass: "tichu" }, [
                              _vm._v(" " + _vm._s(item.comment) + " "),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "me_inner flex_colum" }, [
                      _c(
                        "div",
                        { staticClass: "flex_start flex_center_align" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/r9.png"),
                              alt: "",
                            },
                          }),
                          item.company
                            ? _c("span", { staticClass: "word" }, [
                                _vm._v(" " + _vm._s(item.company) + " "),
                              ])
                            : _c("span", { staticClass: "word" }, [
                                _vm._v("协力会社"),
                              ]),
                        ]
                      ),
                      _c("div", { staticClass: "state_box flex_colum" }, [
                        _c("div", { staticClass: "flex_start" }, [
                          _c(
                            "span",
                            {
                              class:
                                _vm.svgIcon(
                                  item.changeStatus,
                                  item.changeRequestFlg
                                ) === "back_2_line"
                                  ? "state_word_red"
                                  : "state_word_blue",
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "comment_svg",
                                attrs: {
                                  "icon-class": _vm.svgIcon(
                                    item.changeStatus,
                                    item.changeRequestFlg
                                  ),
                                },
                              }),
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getWorkChangTimeStatus(
                                        item.changeStatus,
                                        item.changeRequestFlg
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                        item.comment
                          ? _c("div", { staticClass: "tichu pre_wrap" }, [
                              _vm._v(" " + _vm._s(item.comment) + " "),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ],
            ],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }